import { combineReducers } from 'redux';
import { apiCallReducer } from './apiCallSlice';
import { appReducer } from './appSlice';
import { devicesReducer } from './deviceSlice';
import { imageCacheReducer } from './imageCacheSlice';
import { notificationsReducer } from './notificationsSlice';
import { toastReducer } from './toastSlice';
import { userReducer } from './userSlice';

export const rootReducer = combineReducers({
    app: appReducer,
    toast: toastReducer,
    user: userReducer,
    notifications: notificationsReducer,
    devices: devicesReducer,
    imageCache: imageCacheReducer,
    apiCall: apiCallReducer,
});
